export var ENTITY = "invoice";
export var REDUCER_KEY = "INVOICE_V2";
export var BASE_PATH_ENTITY = "invoices";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
